import { render, staticRenderFns } from "./order-time.vue?vue&type=template&id=7f10e264&scoped=true&lang=html&"
import script from "./order-time.vue?vue&type=script&lang=js&"
export * from "./order-time.vue?vue&type=script&lang=js&"
import style0 from "./order-time.vue?vue&type=style&index=0&id=7f10e264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f10e264",
  null
  
)

export default component.exports